<template>
  <section
    id="pricing-plan"
  >
    <!-- title text and switch button -->
    <div class="text-center">
      <h1 class="mt-0">
        Seguridad
      </h1>
      <p class="mb-2 pb-75">
        Opciones y recomendaciones que te ayudan a proteger tu cuenta.
      </p>
    </div>
    <!--/ title text and switch button -->

    <!-- pricing plan cards -->
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        md="12"
        offset-lg="2"
        class="mx-auto"
      >
        <b-row>
          <b-col md="12">
            <auth-2 />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!--/ pricing plan cards -->
  </section>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Auth2 from './components/Auth2.vue'

export default {
  components: {
    BRow,
    BCol,
    Auth2,
  },
  directives: {
    Ripple,
  },
}

</script>

<style lang="scss">
  @import '@core/scss/vue/pages/page-pricing.scss';
</style>
